export const transactionTypes = [
  { label: "Visa", value: "visa" },
  { label: "Mastercard", value: "mastercard" },
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "ACH", value: "ach" },
  { label: "Amex", value: "amex" },
  { label: "Cash", value: "cash" },
  { label: "Cheque", value: "cheque" },
  { label: "Credit Card", value: "credit_card" },
  { label: "Debit Card", value: "debit_card" },
  { label: "Paypal", value: "paypal" },
  { label: "Stripe", value: "stripe" },
];
